



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,Minus,Plus,X} from 'lucide-react';

  
import "../../Create/CreateCourse/WhatWillYouLearnAddMore.css";
const InstallmentPlanAddMore=({index ,
    value,id,onRemove,changeItemValue})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [itemValue, setItemValue] = useState(value); 
  
 const [amount, setAmount] = useState(itemValue?.amount);
 const [totalNo, setTotalNo] = useState(itemValue?.validityCount);
   const [durationTypeVal, setDurationTypeVal] = useState(itemValue?.validityDurationType);


   const changeAmount = ( Amount) => {
    changeItemValue(id,{amount:Amount,validityCount:totalNo,validityDurationType:durationTypeVal});
    
   };
   const changetotalNumber = ( totalNumber) => {
    changeItemValue(id,{amount:amount,validityCount:totalNumber,validityDurationType:durationTypeVal});
    
   };
   
   const changeDurationType = ( durationType) => {
    changeItemValue(id,{amount:amount,validityCount:totalNo,validityDurationType:durationType});
   
    //  const validityValue= { expiryDate:"",validityCount:itemArr?.validityValue?.validityCount,
    //    validityDurationType:durationType,lifeTimeValidity:true}
     
        // setItemArr({...itemArr,validityDurationType:durationType});
        // handleCreateProductValidityDuration({validityCount:itemArr?.validityCount,validityDurationType:durationType})
    
   };
  
    
     useEffect(()=>{
     
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
   
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<><div 
   
   
   style={{padding:"10px",margin:"5px", marginTop:"0px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"3px solid rgba(144, 202, 249,1)"}}> 
    { <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"0px",
      background:"#958FDA"}} onClick={()=>{onRemove(id);}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>}
    
 
<div  style={{}}><div style={{}}>
<div className=""><h3>  {index==0?"First":index==1?"Second":index==2?"Third":index==3?"Fourth":index==4?"Fifth":(index+1 )+"th"} Installment</h3>
<div style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"25px",marginTop:"40px",paddingBottom:"10px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
      
       
      transition: 'transform 1s ease, opacity 1s ease',
    }}><span className="coloredTextV1" > ₹ </span> Installment Amount  </h3>
    <div style={{display:"flex",justifyContent:"center"}}> <div className="CreateCourseStepsOuterTextbox" style={{"textAlign":"center",
 marginBottom:"0px",
  
  transition: 'transform 1.5s ease, opacity 1.5s ease',
fontSize:"25px",width:"10px"}}>₹</div> <input onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{"textAlign":"center",
      marginBottom:"0px",
       
       transition: 'transform 1s ease, opacity 1s ease',
     fontSize:"20px",width:"190px"}} placeholder={`₹ Installment Amount`} type="number"
  name="courseTitle" value={amount} onChange={(e)=>{ setAmount(e.target.value);changeAmount(e.target.value)
    
     } } /></div>
  </div> 
  <div style={{background:"#fff",borderRadius:"25px",marginTop:"10px",paddingBottom:"10px"}}><h3 style={{paddingTop:"15px",paddingLeft:"20px",
      
       
      transition: 'transform 1s ease, opacity 1s ease',
    }}><span className="coloredTextV1" > ₹ </span>  {index==0?"First":index==1?"Second":index==2?"Third":index==3?"Fourth":index==4?"Fifth":(index+1 )+"th"} Installment  Due In- </h3>
  
  <div className="gridForWhatsNextAfterYT5">
  <div style={{marginTop: '10px' ,paddingLeft:"5px",gridTemplateColumns:  "18% 64% 18%" , }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)>1?parseInt(totalNo)-1:1)
    changetotalNumber(parseInt(totalNo)>1?parseInt(totalNo)-1:1);
  }} style={{float:"left",background:"#555555 ",width:"30px",height:"30px",borderRadius:"50%",marginRight:"10px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="#fff" size={13}/>
    <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  value={parseInt(totalNo)} type="number"
          onChange={(e)=>{changetotalNumber(e.target.value);setTotalNo(e.target.value);}}
          style={{border:"2px dashed #555555  ",borderRadius:"10px",outline:0,float:"left",width:"50px",
            padding:"10px",fontSize:"20px",color:"#555555 ",fontWeight:"bolder"}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)+1)
        changetotalNumber(parseInt(totalNo)+1);
      }}  style={{float:"left",background:"#555555 ",width:"30px",height:"30px",borderRadius:"50%",marginLeft:"10px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="#fff" size={13}/>
        
        
        
        </div>  
        <div class="input-card-radio" >
                               
       <label onMouseEnter={
                            ()=>handleMouseEnter("#fff","#333","")}
             onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                           <div  style={{fontSize:"14px"}} > Months </div> 
             <input type="radio" title="Set As Months"   checked={durationTypeVal=="months"?"yes":""}
  className="input-textbox"  value={durationTypeVal}  name={"courseExpiryType"+(index+1) } 
  onChange={e=>{changeDurationType("months");setDurationTypeVal("months");;}}/>
       <span class={"boxCardBorder"}></span> </label> <label onMouseEnter={
                            ()=>handleMouseEnter("#fff","#333","")}
             onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                           <div style={{fontSize:"14px"}} >Days </div> 
             <input type="radio" title="Set As Days"   checked={durationTypeVal=="days"?"yes":""}
  className="input-textbox"  value={durationTypeVal}  name={"courseExpiryType"+(index+1) }   
  onChange={e=>{changeDurationType("days");setDurationTypeVal("days");}}/>
       <span class={"boxCardBorder"}></span> </label>
       </div>
        </div>                   
        </div> </div> 
            
    
    </div> 
    <div>
    
     
    </div>
    
    </div>
    
    </div></>)
}  

export default InstallmentPlanAddMore;
